import React from 'react'
import { Grid as BaseGrid, Hidden as BaseHidden, styled } from '@mui/material'
import { CheckBox as BaseCheckBox, Button as BaseButton } from '@chilecompra/react-kit/components'
import { Delete as BaseDeleteIcon } from '@mui/icons-material'

export const Image = styled('img')`
  width: 100%;
  ${props => props.theme.breakpoints.down('xs')} {
    max-width: 140px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Root = styled('div')`
  margin: 0;
  padding: 0 0 130px;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin || 'initial'};
    max-width: ${props => props.maxWidth || 'initial'};
    padding: ${props => props.padding || '0'};
    text-align: left;
  }

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const SectionInputContainer = styled(Section)`
  input {
    background: ${props => props.theme.palette.brand.white};
    text-align: left;
    display: flex;
  }
`

export const Instructions = styled('section')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-top: 28px;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: left;
    margin-top: 14px;
  }
`

export const ToastContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Title = styled('h1')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: left;
    margin: 0;
    font-size: 22px;
    line-height: 26px;
  }
`

export const SpinnerRoot = styled('div')`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const DesktopNavigation = styled('div')`
  display: flex;
  justify-content: flex-end;
  margin: 0;
  width: 100%;
  ${props => props.theme.breakpoints.down('lg')} {
    justify-content: center;
  }
`

export const MobileNavigation = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  width: 100%;
`

export const MobileButtons = styled(BaseButton)`
  width: 100%;
  flex-grow: 1;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand[props.color]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: underline;

  &:hover {
    color: ${({ color, theme }) => {
      switch (color) {
        case 'primary':
          return theme.palette.blue[35]
        default:
          return 'inherit'
      }
    }};
  }
`

export const DeleteIcon = styled(BaseDeleteIcon)`
  color: ${props => props.theme.palette.custom.iconGray};
  height: 18px;
  width: 18px;
  cursor: pointer;
`

export const Hidden = styled(BaseHidden)``

export const Grid = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const CheckBox = styled(BaseCheckBox)`
  .MuiCheckbox-root {
    margin: 0;
    padding: 0;
  }
  &.MuiFormControlLabel-root {
    margin: 0 8px 0 0;
  }
`

export const Conditions = styled('div')`
  align-items: center;
  background: rgba(0, 100, 255, 0.03);
  border-radius: 4px;
  border: 1px solid ${props => props.theme.palette.brand.primary};
  color: ${props => props.theme.palette.brand.black1};
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 22px;
  padding: 18px 19px 19px 17px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const DeleteTypography = styled('p')`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
  text-align: center;
  cursor: pointer;
`

export const AttachmentSection = styled('section')`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: -20px;
  padding: 10px;

  && button {
    background-color: ${props => props.disabled && props.theme.palette.custom.dividerGray};
    border-color: ${props => props.disabled && props.theme.palette.custom.dividerGray};
    color: ${props => props.disabled && props.theme.palette.brand.white};
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    margin-top: -38px;
    padding: 18px;

    &:hover {
      background-color: ${props => props.disabled && props.theme.palette.custom.dividerGray};
      border-color: ${props => props.disabled && props.theme.palette.custom.dividerGray};
      color: ${props => props.disabled && props.theme.palette.brand.white};
    }
  }

  && div:nth-child(3) {
    align-items: start;
    display: flex;
    height: 80px;
    justify-content: flex-start;
  }

  ${props => props.theme.breakpoints.down('lg')} {
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    height: 192px;
    z-index: 1;

    && button {
      margin-top: 0;
    }
  }
`
export const AttachmentSubTitle = styled('h2')`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-align: left;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: center;
  }
`

export const AttachmentButtonSection = styled('div')`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
